import { Box, TableCell, Tooltip } from "@mui/material";

interface MaterialCodeCellProps {
  materialCode: string;
  isAdding?: boolean;
  isEditing?: boolean;
  position?: "sticky" | "normal";
  zIndex?: number;
  left?: number;
  width?: number;
}

const MaterialCodeCell = ({
  materialCode,
  isAdding = false,
  isEditing = false,
  position = "sticky",
  zIndex = 101,
  left = 70,
  width = 500,
}: MaterialCodeCellProps) => {
  return (
    <TableCell
      sx={{
        position: position,
        left: left,
        zIndex: zIndex,
        width: width,
        minWidth: width,
        maxWidth: width,
        backgroundColor: isAdding || isEditing ? "#f5f5f5" : "white",
        borderRight: "2px solid #e0e0e0",
        padding: 1,
        fontWeight: "500",
        fontSize: "0.9rem",
      }}
    >
      <Tooltip
        title={materialCode || ""}
        placement="top"
        slotProps={{
          tooltip: {
            sx: {
              fontSize: "1rem",
              fontWeight: 400,
            },
          },
        }}
      >
        <Box
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "100%",
          }}
        >
          {materialCode}
        </Box>
      </Tooltip>
    </TableCell>
  );
};

export default MaterialCodeCell;